import clsx from 'clsx'
import EmptyResults from 'components/EmptyResults'
import GridSpinner from 'components/UI/GridSpinner'
import { parse } from 'date-fns'
import { Button, Container, Icon, Spinner, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import format from 'utils/dateFns/format'
import formatRelative from 'utils/dateFns/formatRelative'
import formatMoney from 'utils/formatMoney'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import StatusIcon from '../StatusIcon'
import styles from 'modules/Finance/PaymentProfiles/Invoices/components/List/payment-profiles-list.module.scss'
import downloadFile from 'utils/downloadFile'
import { APP_PRODUCT } from 'constants/app-config'

const List = ({ data = [], pagination, loading, onNextPage }) => {
  let groupDate = null
  const { t } = useTranslation()
  const breakpoints = useBreakpoint()

  const today = `'${t('common::date_format.today')}'`
  const yesterday = `'${t('common::date_format.yesterday')}'`
  const formatDate = t('common::date_format.long')

  return (
    <div className={styles['list']}>
      {!loading && data.length === 0 && (
        <EmptyResults header={t('payment_profiles::payments.empty_list')} text={' '} />
      )}
      {data.map((invoice, i) => {
        let showDate = false
        const date = format(parse(invoice.created_at, 'yyyy-MM-dd', new Date()), 'dd')

        if (groupDate !== date) {
          showDate = true
          groupDate = date
        }

        return (
          <div key={'invoice-' + i}>
            {showDate && (
              <Typography variant={'p7'} noMargin className={styles['row__date']}>
                {formatRelative(
                  parse(invoice.created_at, 'yyyy-MM-dd', new Date()).getTime(),
                  `${formatDate}`,
                  {
                    today,
                    yesterday,
                  },
                )}
              </Typography>
            )}
            <Container
              className={styles['row']}
              display={'flex'}
              flexJustify={'space-between'}
              flexAlign={'center'}
            >
              <Container display={'flex'} flexAlign={'flex-start'}>
                <div className={styles['row__icon']}>
                  <StatusIcon status={invoice.status} breakpoints={breakpoints} />
                </div>
                <Container display={'flex'} flexDirection={'column'}>
                  <Typography
                    color={'text-primary'}
                    variant={breakpoints.sm ? 'p10' : 'p2'}
                    className={styles['row__title']}
                  >
                    {invoice.invoice_number}
                  </Typography>
                  <Container display={'flex'} flexAlign={'center'}>
                    <Typography
                      variant={breakpoints.sm ? 'p11' : 'p9'}
                      component={'span'}
                      noMargin
                      color={'secondary-grey'}
                    >
                      {t(`payment_profiles::payments.statuses.${invoice.status}`)}
                    </Typography>{' '}
                    <Icon name={'dot'} size={'s'} color={'secondary-grey'} />
                    <Typography
                      variant={breakpoints.sm ? 'p11' : 'p9'}
                      component={
                        <span
                          onClick={() =>
                            downloadFile(
                              `/api/app/v1/billing/invoices/${invoice.id}/document`,
                              `${APP_PRODUCT}-'invoice-'${invoice.invoice_number}`,
                            )
                          }
                          className={styles['row__download-link']}
                          // target={'_blank'}
                          // rel={'noopener noreferrer'}
                          /*href={`/api/app/v1/billing/invoices/${invoice.id}/document`}*/
                        >
                          {t('payment_profiles::payments.download_pdf')}
                          <Icon name={'download'} width={'16px'} />
                        </span>
                      }
                      noMargin
                    />
                  </Container>
                </Container>
              </Container>
              <Typography
                className={styles['row__amount']}
                variant={breakpoints.sm ? 'p8' : 'p3'}
                dangerouslySetInnerHTML={{
                  __html: formatMoney(invoice.amount, invoice.currency),
                }}
              />
            </Container>
          </div>
        )
      })}

      {data.length === 0 && loading && <GridSpinner />}

      {data.length > 0 && pagination.total !== data.length && (
        <div className={styles['pagination']}>
          <Container
            display={'flex'}
            flexAlign={'center'}
            flexJustify={'center'}
            className={styles['show-more__container']}
          >
            <Button
              onClick={() => onNextPage(1)}
              className={clsx(styles['show-more__button'])}
              variant={'link'}
              color={'Label-GU-Primary'}
              startIcon={loading ? <Spinner width={16} color={'inherit'} /> : null}
              endIcon={<Icon name={'arrow1-down'} color={'inherit'} size={'s'} />}
            >
              {t('common::pagination.show_more')}
            </Button>
          </Container>
        </div>
      )}
    </div>
  )
}

List.propTypes = {
  data: PropTypes.array,
  pagination: PropTypes.shape({
    total: PropTypes.number,
  }),
  loading: PropTypes.bool,
  onNextPage: PropTypes.func,
  i18n: PropTypes.string,
  profileId: PropTypes.string,
}

export default List
